import React from 'react';

import * as Form from 'components/form';
import { useForm } from 'components/form';
import * as Page from 'components/page';
import { RHP } from 'providers';

export function CorporateStep6({ useRankingCorporate, t }) {
    const { vars, putUserRankingApplication } = useRankingCorporate;
    const { steps, interests } = vars.application;

    const ack = interests || {};

    const form = useForm({
        realRelationships: !!ack.realRelationships,
        validatedByOtherParty: !!ack.validatedByOtherParty,
        officialPublicationRequiresAudit: !!ack.officialPublicationRequiresAudit,
        auditCost: !!ack.auditCost,
        caseRequirement: !!ack.caseRequirement,
        awardsOptional: !!ack.awardsOptional
    });

    const fields = {
        realRelationships: {
            error: (form.errors as any).realRelationships,
            label: t('CorporateStep6.ack1'),
            name: 'realRelationships',
            type: 'checkbox',
            required: true,
            value: form.values.realRelationships,
            onChange: form.handleChange
        },
        validatedByOtherParty: {
            error: (form.errors as any).validatedByOtherParty,
            label: t('CorporateStep6.ack2'),
            name: 'validatedByOtherParty',
            type: 'checkbox',
            required: true,
            value: form.values.validatedByOtherParty,
            onChange: form.handleChange
        },
        officialPublicationRequiresAudit: {
            error: (form.errors as any).officialPublicationRequiresAudit,
            label: t('CorporateStep6.ack3'),
            name: 'officialPublicationRequiresAudit',
            type: 'checkbox',
            required: true,
            value: form.values.officialPublicationRequiresAudit,
            onChange: form.handleChange
        },
        auditCost: {
            error: (form.errors as any).auditCost,
            label: t('CorporateStep6.ack4'),
            name: 'auditCost',
            type: 'checkbox',
            required: true,
            value: form.values.auditCost,
            onChange: form.handleChange
        },
        caseRequirement: {
            error: (form.errors as any).caseRequirement,
            label: t('CorporateStep6.ack5'),
            name: 'caseRequirement',
            type: 'checkbox',
            required: true,
            value: form.values.caseRequirement,
            onChange: form.handleChange
        },
        awardsOptional: {
            error: (form.errors as any).awardsOptional,
            label: t('CorporateStep6.ack6'),
            name: 'awardsOptional',
            type: 'checkbox',
            required: true,
            value: form.values.awardsOptional,
            onChange: form.handleChange
        }
    };

    // Step 6 (Termo de Ciência) is always accessible - not blocked by step 5
    if (!steps || steps.step4 !== true) {
        RHP.replace('/ranking/latam/corporate/');
        return null;
    }

    const onSubmit = async (values: any) => {
        try {
            const payload = {
                ...vars.application,
                interests: {
                    realRelationships: !!values.realRelationships,
                    validatedByOtherParty: !!values.validatedByOtherParty,
                    officialPublicationRequiresAudit: !!values.officialPublicationRequiresAudit,
                    auditCost: !!values.auditCost,
                    caseRequirement: !!values.caseRequirement,
                    awardsOptional: !!values.awardsOptional
                }
            };

            payload.steps.step6 = true;

            const response = await putUserRankingApplication(payload);

            RHP.push('/ranking/latam/corporate');
            return response;
        } catch (err) {
            console.error(err);
        } finally {
            form.submited();
        }
    };

    // @ts-ignore
    const evSubmit = (ev: any) => form.handleSubmit(ev, onSubmit);

    return (
        <Page.Page name="CorporateStep6" customBackText={t('glossary:backToRanking')}>
            <Page.Title>{t('CorporateStep6.title')}</Page.Title>
            <Page.Descr>{t('CorporateStep6.description')}</Page.Descr>

            <Form.Form name="CorporateStep6Form" onSubmit={evSubmit}>
                <Form.Field {...fields.realRelationships} />
                <Form.Field {...fields.validatedByOtherParty} />
                <Form.Field {...fields.officialPublicationRequiresAudit} />
                <Form.Field {...fields.auditCost} />
                <Form.Field {...fields.caseRequirement} />
                <Form.Field {...fields.awardsOptional} />

                <div style={{ display: 'flex', gap: 10 }}>
                    <Page.Buttn
                        style={{ width: '20%' }}
                        // @ts-ignore
                        to="/ranking/latam/corporate/step5"
                    >
                        <span className="icon far fa-long-arrow-left" aria-hidden="true" />
                        <span className="text">{t('glossary:back')}</span>
                    </Page.Buttn>

                    <div style={{ width: '80%' }}>
                        <Form.Submt text={t('glossary:continue')}>
                            <span className="icon far fa-long-arrow-right" aria-hidden="true" />
                        </Form.Submt>
                    </div>
                </div>
            </Form.Form>
        </Page.Page>
    );
}
